module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-3-en-GB-72ead3f9d3962077279045312ed04f18.png";